<template>
	<div class="app-progress-bar">
		<div class="app-progress-bar__progress" :style="`width: ${progress}%;`"></div>
	</div>
</template>

<script>
export default {
	props: {
		progress: {
			type: Number,
			validator (val) {
				return val >= 0 && val <= 100
			},
			default: 0
		}
	}
}
</script>

<style lang="scss" scoped>
.app-progress-bar {
	height: 8px;
	border-radius: 5px;
	padding: 1px;
	overflow: hidden;
	width: 100%;
	background-color: #EEF9F8;
	box-shadow: inset 0 0 5px #ddd;

	&__progress {
		border-radius: 5px;
		height: 100%;
		background-color: $primary;
		transition: width .5s ease;
	}
}
</style>
